import { defaultThemeSkin } from '@/common/http'
import { themes } from './registry'

export const DEFAULT_THEME = defaultThemeSkin || 'purple'

export { themes }

export function getTheme(name = DEFAULT_THEME) {
    return themes[name] || themes[DEFAULT_THEME] || Object.values(themes)[0]
}

export function getThemeImage(name = DEFAULT_THEME, path = '') {
    const theme = getTheme(name)
    return path.split('.').reduce((value, key) => value && value[key], theme.assets)
}

export function applyTheme(name = DEFAULT_THEME) {
    const theme = getTheme(name)
    const root = document.documentElement

    root.setAttribute('data-theme', theme.name)
    Object.keys(theme.cssVars).forEach((key) => {
        root.style.setProperty(key, theme.cssVars[key])
    })

    return theme
}
